<!-- Left Side - Workspace List -->
<div class="col-span-3 lg:col-span-2 bg-white dark:bg-indigo-custom rounded-xl flex flex-col h-full overflow-hidden">
  <h2 class="text-secondary dark:text-white text-lg font-semibold mb-2">Workspace</h2>

  <!-- Scrollable Workspace List -->
  <div class="flex-1 overflow-y-auto custom-scroll">
    <!-- Loading State -->
    <div *ngIf="loading$ | async" class="flex justify-around items-center h-full">
      <svg class="animate-spin h-6 w-6 text-blue-royal" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
      </svg>
    </div>

    <!-- Error State -->
    <div *ngIf="error$ | async as error" class="bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg p-4 mb-4">
      <p class="text-red-600 dark:text-red-400 text-sm">{{ error }}</p>
    </div>

    <!-- Workspaces List -->
    <div *ngIf="!(loading$ | async)" class="space-y-3">
      <div *ngFor="let workspace of workspaces$ | async"
           class="flex items-center gap-3 p-4 bg-gray-50 dark:bg-gray-800/50 rounded-xl hover:bg-gray-100 dark:hover:bg-gray-700/50 cursor-pointer transition-colors duration-150"
           (click)="selectWorkspace(workspace)">
        <!-- Workspace Icon -->
        <div class="flex-shrink-0">
          <div [class]="'w-12 h-12 rounded-lg flex items-center justify-center text-white font-semibold text-lg ' + workspace.color">
            {{ workspace.initials }}
          </div>
        </div>

        <!-- Workspace Details -->
        <div class="flex-grow min-w-0">
          <h3 class="text-base font-semibold text-gray-900 dark:text-gray-100 mb-1">
            {{ workspace.name }}
          </h3>
          <p class="text-xs text-gray-600 dark:text-gray-400">
            {{ workspace.searches_count }} searches • Created {{ workspace.created_at | date:'mediumDate' }} • {{ workspace.total_files }} files attached
            <span *ngIf="workspace.icp">• ICP: {{ workspace.icp.name }}</span>
          </p>
        </div>

        <!-- Arrow Icon -->
        <div class="flex-shrink-0 flex items-center">
          <svg class="w-4 h-4 text-gray-400 dark:text-gray-500" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
            <path fill-rule="evenodd" d="M8.22 5.22a.75.75 0 0 1 1.06 0l4.25 4.25a.75.75 0 0 1 0 1.06l-4.25 4.25a.75.75 0 0 1-1.06-1.06L11.94 10 8.22 6.28a.75.75 0 0 1 0-1.06Z" clip-rule="evenodd" />
          </svg>
        </div>
      </div>
    </div>

    <!-- Empty State (shown when no workspaces) -->
    <div *ngIf="!(loading$ | async) && (workspaces$ | async)?.length === 0" class="flex flex-col items-center justify-center h-full py-12">
      <div class="mx-auto w-16 h-16 bg-gray-100 dark:bg-gray-800 rounded-xl flex items-center justify-center mb-4">
        <svg class="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"></path>
        </svg>
      </div>
      <p class="text-gray-500 dark:text-gray-400">No workspaces available</p>
      <p class="text-sm text-gray-400 dark:text-gray-500 mt-1">Create your first workspace to get started</p>
    </div>
  </div>
</div>
